import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const ReminderRoutes = ({
  List,
  Warranty,
  SetupTime,
}: {
  List: React.ComponentType;
  Warranty: React.ComponentType;
  SetupTime: React.ComponentType;
}) => (
  <Routes>
    <Route path={ROUTES.REMINDERS.REMINDLIST.BASE} element={<List />} />
    <Route path={ROUTES.REMINDERS.REMINDTYPE.BASE} element={<Warranty />} />
    <Route path={ROUTES.REMINDERS.SETUP_TIME.BASE} element={<SetupTime />} />
  </Routes>
);
